export const VARIANT_STYLES_ALERT = {
  default: "border border-border bg-card/60 backdrop-blur-sm",
  info: "border border-info/30 bg-info/10 backdrop-blur-sm",
  success: "border border-success/30 bg-success/10 backdrop-blur-sm",
  warning: "border border-warning/30 bg-warning/10 backdrop-blur-sm",
  error: "border border-destructive/30 bg-destructive/10 backdrop-blur-sm",
};
